import React from "react";

import { Box } from "@material-ui/core";

import {
  ArrayInput,
  Button,
  FormDataConsumer,
  SimpleFormIterator,
} from "react-admin";
import { AddIcon, RemoveIcon } from "../../../../components/common/iconography";
import { ShipmentLineItemStatus } from "../../../../utils/constants";
import { PickListInventoryItem } from "./PickListInventoryItem";

export const PickListInventoryItems = ({
  record,
  setAddOpen,
  handleQuantityChange,
  ...props
}) => {
  const AddButton = () => (
    <Button label="ADD" color="default" onClick={() => setAddOpen(true)}>
      <AddIcon />
    </Button>
  );
  const RemoveButton = ({ record, ...props }) => {
    const handleRemove = (event) => {
      props.onClick(event);
      handleQuantityChange();
    };
    if (
      record?.status === ShipmentLineItemStatus.LOADED ||
      record?.status === ShipmentLineItemStatus.VERIFIED ||
      record?.status === ShipmentLineItemStatus.SHIPPED
    ) {
      return <></>;
    }
    return (
      <Button label="REMOVE" color="default" onClick={handleRemove}>
        <RemoveIcon />
      </Button>
    );
  };

  return (
    <Box mt={-3}>
      <ArrayInput source="inventoryItems.items" label={false} fullWidth>
        <SimpleFormIterator
          disableReordering={true}
          addButton={<AddButton />}
          disableAdd={
            record.status === ShipmentLineItemStatus.LOADED ||
            record.status === ShipmentLineItemStatus.VERIFIED ||
            record.status === ShipmentLineItemStatus.SHIPPED
          }
          removeButton={<RemoveButton record={record} />}
          disableRemove={
            record.status === ShipmentLineItemStatus.LOADED ||
            record.status === ShipmentLineItemStatus.VERIFIED ||
            record.status === ShipmentLineItemStatus.SHIPPED
          }
        >
          <FormDataConsumer>
            {({
              formData, // The whole form data
              scopedFormData, // The data for this item of the ArrayInput
              getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
            }) => (
              <PickListInventoryItem
                source={getSource()} //dummy to disable warning
                getSource={getSource}
                record={record}
                formData={formData}
                scopedFormData={scopedFormData}
                handleQuantityChange={handleQuantityChange}
              />
            )}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>
    </Box>
  );
};
